export const votingStore = {
    state: () => ({
        
    }),
    mutations: {
        
    }
}